//
//
//
//
//
//
//
//
//
//
//

	import SVGA from "svgaplayerweb";
	export default {
		props: {
			box_model: {
				type: String
			},
			animation_status: {
				type: Number
			}
		},
		name: 'boxmodel',
		data() {
			return {
				down: false,
				offsetX: undefined,
				frame: 11
			}
		},
		methods: {

			load() { //初始
				this.player = new SVGA.Player("#modelCanvas")
				this.parser = new SVGA.Parser("#modelCanvas")
				let new_svga = this.box_model
				this.parser.load(new_svga, (videoItem) => {
					this.player.loops = 1
					this.player.clearsAfterStop = false
					this.player.setVideoItem(videoItem)
					this.player.stepToFrame(11, false)
					this.$emit('initial')
				})
			},

			//按下
			mousedown(event) {
				this.offsetX = event.offsetX
				this.down = true
			},

			//移动
			mousemove(event) {
				//按下并移动
				if (this.down) {
					let value = event.offsetX - this.offsetX
					if (value > 0) {
						if (this.frame < 32) {
							this.frame += 1
							this.player.stepToFrame(this.frame, false)
							//右
						}
					} else {
						if (this.frame > 0) {
							this.frame -= 1
							this.player.stepToFrame(this.frame, false)
							//左
						}
					}
					this.offsetX = event.offsetX
				}
			},

			//松开
			mouseup(event) {
				this.down = false
				this.offsetX = undefined
			},

			//划离
			mouseout(event) {
				this.down = false
				this.offsetX = undefined
			},

			//位置归位
			homing(item) {
				if (this.frame == 11) {
					this.$emit('returned', item)
				} else {
					if (this.frame > 11) {
						let timer = setInterval(() => {
							this.frame -= 1
							this.player.stepToFrame(this.frame, false)
							if (this.frame == 11) {
								clearInterval(timer)
								this.$emit('returned', item)
							}
						}, 10)
					} else {
						let timer = setInterval(() => {
							this.frame += 1
							this.player.stepToFrame(this.frame, false)
							if (this.frame == 11) {
								clearInterval(timer)
								this.$emit('returned', item)
							}
						}, 10)
					}
				}
			}
		},
		watch: {
			box_model(v) {
				if (v) this.load()
			}
		}
	}
